/**
 * Sacred Waters — choice, cart and ambient sound.
 *
 * The nine water cards and the six vessel swatches are the single
 * source of truth for what can be picked. The chips in the closing
 * panel are BUILT from them at boot, so a merchant who adds a tenth
 * water in the theme editor gets it everywhere without touching this
 * file, and the two surfaces cannot drift out of sync.
 */
(function () {
  'use strict';

  var html = document.documentElement;
  var root = document.querySelector('[data-sw-root]');
  if (!root) return;

  function handleize(s) {
    return String(s || '')
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ================================================================ */
  /* Ambient sound                                                    */
  /* ================================================================ */
  var soundBtn = $('[data-sw-sound]');
  var audioSrc = root.getAttribute('data-sw-audio');
  var audio = null;
  var fadeTimer = 0;

  function fade(to, done) {
    if (!audio) return;
    clearInterval(fadeTimer);
    var step = (to - audio.volume) / 22;
    fadeTimer = setInterval(function () {
      var v = audio.volume + step;
      if ((step > 0 && v >= to) || (step < 0 && v <= to)) {
        clearInterval(fadeTimer);
        audio.volume = Math.max(0, Math.min(1, to));
        if (done) done();
        return;
      }
      audio.volume = Math.max(0, Math.min(1, v));
    }, 40);
  }

  if (soundBtn && audioSrc) {
    soundBtn.addEventListener('click', function () {
      var on = soundBtn.getAttribute('aria-pressed') === 'true';
      if (!audio) {
        audio = new Audio(audioSrc);
        audio.loop = true;
        audio.volume = 0;
        audio.preload = 'none';
      }
      if (on) {
        fade(0, function () { audio.pause(); });
        soundBtn.setAttribute('aria-pressed', 'false');
      } else {
        /* a play() rejection is normal — it means the browser wanted a
           gesture it did not count. Leave the pill off rather than
           lying about the state. */
        var p = audio.play();
        if (p && p.catch) {
          p.then(function () {
            soundBtn.setAttribute('aria-pressed', 'true');
            fade(0.5);
          }).catch(function () {
            soundBtn.setAttribute('aria-pressed', 'false');
          });
        } else {
          soundBtn.setAttribute('aria-pressed', 'true');
          fade(0.5);
        }
      }
      var offL = $('.sw-sound__label--off', soundBtn);
      var onL = $('.sw-sound__label--on', soundBtn);
      var nowOn = soundBtn.getAttribute('aria-pressed') === 'true';
      if (offL) offL.hidden = nowOn;
      if (onL) onL.hidden = !nowOn;
    });
  } else if (soundBtn) {
    soundBtn.hidden = true;
  }

  /* ================================================================ */
  /* Choice                                                           */
  /* ================================================================ */
  var pick = { water: null, color: null };

  var waterBtns = $$('[data-sw-choose]');
  var colorBtns = $$('[data-sw-swatch]');

  function dataOf(btn, kind) {
    return {
      kind: kind,
      handle: btn.getAttribute('data-sw-handle') || handleize(btn.getAttribute('data-sw-name')),
      alt: btn.getAttribute('data-sw-alt') || '',
      name: btn.getAttribute('data-sw-name') || '',
      hue: btn.getAttribute('data-sw-hue') || '',
      img: btn.getAttribute('data-sw-img') || '',
      dot: btn.getAttribute('data-sw-dot') || ''
    };
  }

  /* ---- build the closing panel's chips from the sections above ---- */
  function buildChips() {
    var wWrap = $('[data-sw-config-waters]');
    var cWrap = $('[data-sw-config-colors]');
    /* iterate a copy: the new chips are pushed onto the same arrays */
    if (wWrap) {
      waterBtns.slice().forEach(function (src) {
        var d = dataOf(src, 'water');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sw-chip';
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', 'false');
        b.setAttribute('data-sw-choose', '');
        b.setAttribute('data-sw-handle', d.handle);
        b.setAttribute('data-sw-name', d.name);
        b.setAttribute('data-sw-alt', d.alt);
        if (d.hue) { b.setAttribute('data-sw-hue', d.hue); b.style.setProperty('--sw-hue', d.hue); }
        b.innerHTML = '<i class="sw-chip__dot" aria-hidden="true"></i><span></span>';
        b.lastChild.textContent = d.name;
        wWrap.appendChild(b);
        waterBtns.push(b);
      });
    }
    if (cWrap) {
      colorBtns.slice().forEach(function (src) {
        var d = dataOf(src, 'color');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sw-chip sw-chip--color';
        if (d.dot) b.style.setProperty('--dot', d.dot);
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', 'false');
        b.setAttribute('data-sw-swatch', '');
        b.setAttribute('data-sw-handle', d.handle);
        b.setAttribute('data-sw-name', d.name);
        /* a 30px crop of a full-length product photo is unreadable —
           the colour itself is the only legible token at this size */
        var sw = document.createElement('i');
        sw.className = 'sw-chip__swatch';
        sw.setAttribute('aria-hidden', 'true');
        b.appendChild(sw);
        var sp = document.createElement('span');
        sp.textContent = d.name;
        b.appendChild(sp);
        cWrap.appendChild(b);
        colorBtns.push(b);
      });
    }
  }
  buildChips();

  /* ---- vessel stage ---------------------------------------------- */
  var stageImgs = $$('[data-sw-stage-img]');
  var swatchNow = $('[data-sw-swatch-now]');

  /* ---- sticky bar ------------------------------------------------- */
  var barTitle = $('[data-sw-bar-title]');
  var barSub = $('[data-sw-bar-sub]');
  var barThumb = $('[data-sw-bar-thumb]');

  /* ---- product / variants ---------------------------------------- */
  var product = null;
  var productEl = $('[data-sw-product]');
  if (productEl) {
    try { product = JSON.parse(productEl.textContent); } catch (e) { product = null; }
  }

  function optionIndex(names, words, fallback) {
    for (var i = 0; i < names.length; i++) {
      var n = String(names[i]).toLowerCase();
      for (var j = 0; j < words.length; j++) {
        if (n.indexOf(words[j]) !== -1) return i;
      }
    }
    return fallback;
  }

  function valueMatches(value, choice) {
    if (!choice) return false;
    var v = handleize(value);
    var keys = [choice.handle, choice.alt ? handleize(choice.alt) : '', handleize(choice.name)];
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (!k) continue;
      if (v === k || v.indexOf(k) !== -1 || k.indexOf(v) !== -1) return true;
    }
    return false;
  }

  function matchVariant() {
    if (!product || !product.variants || !product.variants.length) return null;
    var names = product.options || [];
    var wi = optionIndex(names, ['water', 'source', 'spring'], 0);
    var ci = optionIndex(names, ['color', 'colour', 'vessel', 'glass'], names.length > 1 ? 1 : -1);
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var okW = wi < 0 || !pick.water || valueMatches(v.options[wi], pick.water);
      var okC = ci < 0 || !pick.color || valueMatches(v.options[ci], pick.color);
      if (okW && okC) return v;
    }
    return null;
  }

  /* ---- the button state machine ---------------------------------- */
  var cta = $('[data-sw-cta-btn]');
  var ctaLabel = cta ? $('[data-sw-cta-label]', cta) : null;
  var ctaPrice = cta ? $('[data-sw-cta-price]', cta) : null;
  var status = $('[data-sw-config-status]');
  var added = false;

  function label(key) {
    return (cta && cta.getAttribute('data-sw-label-' + key)) || '';
  }

  function render() {
    waterBtns.forEach(function (b) {
      var on = !!pick.water && (b.getAttribute('data-sw-handle') || '') === pick.water.handle;
      b.setAttribute(b.hasAttribute('role') && b.getAttribute('role') === 'radio' ? 'aria-checked' : 'aria-pressed', on ? 'true' : 'false');
    });
    colorBtns.forEach(function (b) {
      var on = !!pick.color && (b.getAttribute('data-sw-handle') || '') === pick.color.handle;
      b.setAttribute(b.getAttribute('role') === 'radio' ? 'aria-checked' : 'aria-pressed', on ? 'true' : 'false');
    });

    stageImgs.forEach(function (im) {
      im.classList.toggle('is-on', !!pick.color && im.getAttribute('data-sw-stage-img') === pick.color.handle);
    });
    if (stageImgs.length && !pick.color) stageImgs[0].classList.add('is-on');

    if (swatchNow) {
      swatchNow.textContent = pick.color
        ? (swatchNow.getAttribute('data-sw-prefix') || '') + pick.color.name
        : '';
    }

    if (pick.water && pick.water.hue) {
      html.style.setProperty('--sw-accent', pick.water.hue);
    }

    /* bar */
    if (barTitle) {
      barTitle.textContent = pick.water
        ? pick.water.name
        : (barTitle.getAttribute('data-sw-default') || '');
    }
    if (barSub) {
      var bits = [];
      if (pick.water && pick.water.alt) bits.push(pick.water.alt);
      if (pick.color) bits.push(pick.color.name);
      barSub.textContent = bits.length ? bits.join(' · ') : (barSub.getAttribute('data-sw-default') || '');
    }
    if (barThumb && pick.color && pick.color.img) barThumb.src = pick.color.img;

    /* CTA */
    if (!cta) return;
    var variant = matchVariant();
    var mode, text, price = '';

    if (added) {
      mode = 'added';
      text = label('added');
      cta.setAttribute('href', '/checkout');
    } else if (!pick.water) {
      mode = 'need-water';
      text = label('empty');
    } else if (colorBtns.length && !pick.color) {
      mode = 'need-color';
      text = label('color');
    } else if (product && !variant) {
      mode = 'nomatch';
      text = label('chosen');
    } else if (variant && !variant.available) {
      mode = 'soldout';
      text = label('soldout');
    } else {
      mode = 'add';
      text = label('chosen');
      price = variant ? variant.price : (cta.getAttribute('data-sw-price') || '');
    }

    cta.setAttribute('data-sw-mode', mode);
    cta.setAttribute('aria-disabled', mode === 'soldout' ? 'true' : 'false');
    if (ctaLabel) ctaLabel.textContent = text;
    if (ctaPrice) ctaPrice.textContent = price;

    if (mode !== 'added') {
      var base = cta.getAttribute('data-sw-base-href') || '#';
      if (product && product.url) {
        base = product.url + (variant ? '?variant=' + variant.id : '');
      } else if (base && base !== '#') {
        var q = [];
        if (pick.water) q.push('water=' + encodeURIComponent(pick.water.handle));
        if (pick.color) q.push('color=' + encodeURIComponent(pick.color.handle));
        if (q.length) base += (base.indexOf('?') === -1 ? '?' : '&') + q.join('&');
      }
      cta.setAttribute('href', base);
    }

    if (status) {
      if (mode === 'need-water') status.textContent = status.getAttribute('data-sw-need-water') || '';
      else if (mode === 'need-color') status.textContent = status.getAttribute('data-sw-need-color') || '';
      else if (mode === 'soldout') status.textContent = status.getAttribute('data-sw-soldout') || '';
      else if (mode === 'added') status.textContent = status.getAttribute('data-sw-added') || '';
      else {
        var parts = [];
        if (pick.water) parts.push(pick.water.name);
        if (pick.color) parts.push(pick.color.name);
        status.textContent = parts.join(' · ') + (price ? ' — ' + price : '');
      }
    }
  }

  function choose(kind, btn) {
    var d = dataOf(btn, kind);
    var cur = pick[kind];
    pick[kind] = (cur && cur.handle === d.handle) ? null : d;
    added = false;
    render();
    return pick[kind] !== null;
  }

  function bindPickers() {
    document.addEventListener('click', function (e) {
      var w = e.target.closest && e.target.closest('[data-sw-choose]');
      if (w) {
        var chose = choose('water', w);
        /* Picking a water from a card carries you to the vessel step —
           that is the next decision, and it is off screen. Skipped when
           the click DESELECTS, and skipped for the chips in the closing
           panel, which would throw someone out of the panel they are
           already using. */
        if (chose && w.classList.contains('sw-water')) {
          var next = document.querySelector('[data-sw-next-step]');
          if (next) {
            setTimeout(function () {
              next.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 260);
          }
        }
        return;
      }
      var c = e.target.closest && e.target.closest('[data-sw-swatch]');
      if (c) { choose('color', c); }
    });
  }
  bindPickers();

  /* ---- add to cart ------------------------------------------------ */
  if (cta) {
    cta.addEventListener('click', function (e) {
      var mode = cta.getAttribute('data-sw-mode');
      if (mode === 'soldout') { e.preventDefault(); return; }
      if (mode === 'need-water' || mode === 'need-color') {
        e.preventDefault();
        var target = document.querySelector(
          mode === 'need-water' ? '[data-sw-step="water"]' : '[data-sw-step="color"]'
        );
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if (mode !== 'add') return; /* 'added' and 'nomatch' are real links */
      var variant = matchVariant();
      if (!variant) return;
      e.preventDefault();
      if (ctaLabel) ctaLabel.textContent = label('adding');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function () {
        added = true;
        render();
      }).catch(function () {
        /* fall back to the product page rather than leaving a dead
           button — the visitor can still complete the purchase */
        location.href = (product && product.url ? product.url : '/cart') +
          (variant ? '?variant=' + variant.id : '');
      });
    });
  }

  /* ---- preselect from the URL ------------------------------------- */
  (function preselect() {
    var q = new URLSearchParams(location.search);
    var w = q.get('water');
    var c = q.get('color');
    if (w) {
      var wb = waterBtns.filter(function (b) { return b.getAttribute('data-sw-handle') === w; })[0];
      if (wb) pick.water = dataOf(wb, 'water');
    }
    if (c) {
      var cb = colorBtns.filter(function (b) { return b.getAttribute('data-sw-handle') === c; })[0];
      if (cb) pick.color = dataOf(cb, 'color');
    }
  })();

  render();
  html.classList.add('sw-ready');
})();
